import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

export const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Company Info */}
          <div>
            <div className="text-2xl font-bold mb-4" style={{ color: '#3b82f6' }}>
              NanoGen
            </div>
            <p className="text-sm mb-3">{t.footer.description}</p>
            <p className="text-sm">
              <span className="text-gray-400">{language === 'tr' ? 'İletişim için: ' : 'For contact: '}</span>
              <a
                href="mailto:info@nanogenindustrial.com"
                data-testid="footer-email-link"
                className="font-medium text-blue-400 hover:text-blue-300 transition-colors"
              >
                info@nanogenindustrial.com
              </a>
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">{t.footer.quickLinks}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-blue-400 transition-colors">
                  {t.nav.home}
                </Link>
              </li>
              <li>
                <Link to="/services" className="hover:text-blue-400 transition-colors">
                  {t.nav.services}
                </Link>
              </li>
              <li>
                <Link to="/catalog" className="hover:text-blue-400 transition-colors">
                  {t.nav.catalog}
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-400 transition-colors">
                  {t.nav.about}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-blue-400 transition-colors">
                  {t.nav.contact}
                </Link>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">{t.footer.legal}</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="hover:text-blue-400 transition-colors">
                  {t.footer.privacy}
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="hover:text-blue-400 transition-colors">
                  {t.footer.cookies}
                </Link>
              </li>
              <li>
                <Link to="/kvkk" className="hover:text-blue-400 transition-colors">
                  {t.footer.kvkk}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8 text-center text-sm">
          <p>© {new Date().getFullYear()} NanoGen. {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
};
